import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatabasesDisplayGridRowDataFragmentGql } from './DatabasesDisplayGridRowFragmentGql';

export const DatabasesQueryGql: DocumentNode = gql`
query DatabasesQuery(
  $first: Int!,
  $offset: Int!,
  $textSearch: String,
  $orderBy: DatabaseSortOrder!,
  $hasActiveWarning: Boolean,
  $isCertified: Boolean,
  $publishedConnectionsLineageEnabled: Boolean!
  ) {
  databasesConnection(
    first: $first,
    offset: $offset,
    orderBy: $orderBy,
    filter: {
      hasActiveWarning: $hasActiveWarning,
      isCertified: $isCertified,
      text: $textSearch
    },
    permissionMode: FILTER_RESULTS
  ) {
    totalCount
    nodes {
      ...DatabasesDisplayGridRowDataFragment
    }
  }
  maxDownstreamDatasources: databasesConnection(
    filter: {
      hasActiveWarning: $hasActiveWarning,
      isCertified: $isCertified,
      text: $textSearch
    }
    orderBy: { field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC }
    first: 1,
    permissionMode: FILTER_RESULTS
  ) {
    nodes {
      downstreamDatasourcesConnection { totalCount }
    }
  }
  maxDownstreamWorkbooks: databasesConnection(
    filter: {
      hasActiveWarning: $hasActiveWarning,
      isCertified: $isCertified,
      text: $textSearch
    }
    orderBy: { field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC }
    first: 1,
    permissionMode: FILTER_RESULTS
  ) {
    nodes {
      downstreamWorkbooksConnection { totalCount }
    }
  }
}
${DatabasesDisplayGridRowDataFragmentGql}
`;
